import { SETTLEMENT_EXPORT_SYSTEM_FEATURE_FLAG } from 'api/settlementExports/settlementExports.constants'
import { useHasGlobalPermission, useHasPermission } from 'helpers/global.helper/global.helper'
import { useSystemFeatureFlagIsActive } from 'utils/systemUtils'

type SettlementExportAccess = {
  canView: boolean
  canRun: boolean
}

/**
 * Nothing is available on a system without the feature flag, whatever the user's permissions —
 * superusers included. Where the flag is set, the server grants each permission through a system
 * role, a global role or superuser status; `system_permissions` only lists the first, so global
 * roles are checked separately, or users holding the permission through one would lose a button
 * the API lets them use.
 */
export function useSettlementExportAccess(): SettlementExportAccess {
  const isEnabledForSystem = useSystemFeatureFlagIsActive(SETTLEMENT_EXPORT_SYSTEM_FEATURE_FLAG)
  const hasSystemView = useHasPermission('view_settlement_export')
  const hasGlobalView = useHasGlobalPermission('view_settlement_export')
  const hasSystemRun = useHasPermission('run_settlement_export')
  const hasGlobalRun = useHasGlobalPermission('run_settlement_export')

  const canRun = isEnabledForSystem && (hasSystemRun || !!hasGlobalRun)
  // Product decision: running an export also lets the user list and download them.
  const canView = isEnabledForSystem && (hasSystemView || !!hasGlobalView || canRun)

  return { canView, canRun }
}
